import { render } from "./DownloadWindowSettings.vue?vue&type=template&id=322cfabc&scoped=true"
import script from "./DownloadWindowSettings.vue?vue&type=script&lang=js"
export * from "./DownloadWindowSettings.vue?vue&type=script&lang=js"

import "./DownloadWindowSettings.vue?vue&type=style&index=0&id=322cfabc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322cfabc"]])

export default __exports__